import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="w-full px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-white mb-4">Hotel A.S.K Grand</h3>
            <p className="text-gray-400 mb-4">
              Your trusted budget hotel in Gajuwaka, Visakhapatnam. Experience comfort, cleanliness, and convenience.
            </p>
            <div className="flex text-yellow-500 mb-2">
              {/* 4 full stars */}
              {[...Array(4)].map((_, i) => (
                <svg key={i} className="w-4 h-4 fill-current" viewBox="0 0 20 20">
                  <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                </svg>
              ))}
              {/* Half star for 4.7 rating */}
              <div className="relative">
                <svg className="w-4 h-4 text-gray-400 fill-current" viewBox="0 0 20 20">
                  <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                </svg>
                <svg className="w-4 h-4 text-yellow-500 fill-current absolute top-0 left-0 overflow-hidden" viewBox="0 0 20 20" style={{ clipPath: 'inset(0 30% 0 0)' }}>
                  <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                </svg>
              </div>
            </div>
            <p className="text-gray-400 text-sm">4.7 Guest Rating</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => document.getElementById('rooms')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-white transition">
                  Our Rooms
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('amenities')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-white transition">
                  Amenities
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('location')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-white transition">
                  Location
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-white transition">
                  Book Now
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-1 flex-shrink-0" />
                <a href="tel:+917799933325" className="hover:text-white transition">
                  +91 7799933325
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-1 flex-shrink-0" />
                <span className="text-sm">askgrandgajuwaka@gmail.com</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span className="text-sm">10-2-9/1, Mehar Nagar, Old Gajuwaka, Visakhapatnam, Andhra Pradesh 530026</span>
              </li>
            </ul>
          </div>

          {/* Room Types */}
          <div>
            <h4 className="text-white mb-4">Room Types</h4>
            <ul className="space-y-2">
              <li className="text-gray-400">Suite Rooms</li>
              <li className="text-gray-400">Royal Rooms</li>
              <li className="text-gray-400">Single Rooms</li>
              <li className="text-gray-400">All AC with TV & Wi-Fi</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} Hotel A.S.K Grand. All rights reserved.
          </p>
          
          <div className="flex gap-4">
            <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-indigo-600 transition">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-indigo-600 transition">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-indigo-600 transition">
              <Twitter className="w-4 h-4" />
            </a>
          </div>
        </div>

        {/* SEO Keywords Footer */}
        <div className="mt-6 pt-6 border-t border-gray-800 text-center">
          <p className="text-gray-500 text-xs">
            Budget Hotel Old Gajuwaka • Hotel Near Vizag Airport • Old Gajuwaka Suites • AC Rooms Visakhapatnam • Budget Accommodation Old Gajuwaka • Hotel Near Steelplant
          </p>
        </div>
      </div>
    </footer>
  );
}
